import { render } from "./MyInformation.vue?vue&type=template&id=120d5fca"
import script from "./MyInformation.vue?vue&type=script&lang=js"
export * from "./MyInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__